import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Loader = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6868_4876)">
      <path d="M20.995 16.3732C20.7846 16.8046 20.5428 17.2319 20.2605 17.6282C17.1479 22.1849 10.8937 23.3513 6.31 20.2256C5.96779 19.9919 5.87811 19.5143 6.10738 19.1811C6.34104 18.8389 6.80533 18.7538 7.15652 18.9918C9.04313 20.2792 11.3153 20.7532 13.5519 20.342C15.7885 19.9309 17.7304 18.6639 19.009 16.7953C21.6498 12.932 20.6448 7.62425 16.7545 4.97026C14.8679 3.68294 12.5958 3.20892 10.3592 3.62007C8.12259 4.03122 6.18067 5.29816 4.90211 7.1668C4.66845 7.509 4.20417 7.59408 3.85298 7.35604C3.51077 7.12238 3.43007 6.64911 3.65036 6.31151C6.76291 1.75479 13.0218 0.601808 17.5965 3.72312C21.7614 6.56671 23.1209 11.9917 20.9816 16.3778L20.995 16.3732Z" />
    </g>
    <defs>
      <clipPath id="clip0_6868_4876">
        <rect width="24" height="24" />
      </clipPath>
    </defs>
  </svg>
)

export default withDefaultStyles(Loader)
